import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const BillingServiceMethodSchema = z.object({
  type: z.string(),
  id: z.string(),
  created: z.number().optional(),
  card: z
    .object({
      brand: z.string(),
      last4: z.string(),
      exp_month: z.number(),
      exp_year: z.number(),
    })
    .optional(),
  customer: z.string().optional(),
})

export type BillingServiceMethod = ZodSimplify<
  typeof BillingServiceMethodSchema
>
